import { SellerReviewsJs, _t } from '@bark/bark-core';

export default async function () {
	SellerReviewsJs();

	const getHiredSeller = () => {
		const {
			Bark: { api },
		} = window;
		api(
			'buyer/bark/hired-seller',
			{ bid: getProjectIdH() },
			(response) => {
				const { data } = response;
				hideLoading();
				renderCloseBark(data);
			},
			(error) => {},
			'GET',
		);
	};

	const renderCloseBark = (data) => {
		$('.data-company-name').html(data.company_name);
		$('#spidh-hv').val(data.seller_profile_id);
		$('#closed-bark-form').removeClass('invisible');
		$('#review_user_review').attr(
			'placeholder',
			_t('seller_profile:add-review-modal.form.review.placeholder', {
				company_name: data.company_name,
			}),
		);
	};

	const getProjectIdH = () => {
		return $('#project-idh').val();
	};

	const hideLoading = () => {
		$('.closed-bark-loading').addClass('d-none');
	};

	const addEventListeners = () => {
		$('.stars .fa-star')
			.unbind('mouseenter.hired-highlight')
			.on('mouseenter.hired-highlight', function () {
				var index = $('.stars .fa-star').index(this);
				var i = 0;
				for (i = 0; i < index + 1; i++) {
					$('.stars .fa-star').eq(i).addClass('highlighted');
				}
			});

		$('.stars .fa-star')
			.unbind('mouseleave.hired-highlight')
			.on('mouseleave.hired-highlighted', function () {
				$('.stars .fa-star').removeClass('highlighted');
			});

		$('.stars .fa-star')
			.unbind('click.hired-highlight')
			.on('click.hired-highlight', function () {
				var index = $('.stars .fa-star').index(this);
				var i = 0;
				$('.stars .fa-star').unbind('mouseenter.highlight');
				$('.stars .fa-star').unbind('mouseleave.highlight');
				for (i = 0; i < index + 1; i++) {
					$('.stars .fa-star').eq(i).addClass('highlighted');
				}
			});

		$('.stars .fa-star')
			.unbind('click.open-review-modal')
			.on('click.open-review-modal', function () {
				$('#add-review-modal').modal('show');
				var index = $('.stars .fa-star').index(this) + 1;
				$('#_rvform ._st' + index).click();
			});
	};

	getHiredSeller();
	addEventListeners();
}
